import { PageHeading } from "@components/headings/page";
import { SanitizeHTML } from "@components/sanitizeHtml";
import { makeLpTitle } from "@utils/makeLpTitle";
import { LP_URL } from "@constants/lpUrl";
import { NextHead } from "@components/nextHead";

export default function GamesOnTheGo() {
  const metaTitle =
    "Games on the go: the answers to our visual puzzles for kids";
  const metaDescription =
    "Get the answers to our visual puzzles for kids, taken from the Lonely Planet Kids book, Games on the Go! Grown-ups might find them a challenge too...";
  const canonicalUrl = `${LP_URL}/kids/games-on-the-go-answers`;

  return (
    <div>
      <NextHead>
        <title>{makeLpTitle(metaTitle)}</title>
        <link key="canonical" rel="canonical" href={canonicalUrl} />
        <meta key="title" name="title" content={makeLpTitle(metaTitle)} />
        <meta key="description" name="description" content={metaDescription} />
        <meta
          key="og:title"
          property="og:title"
          content={makeLpTitle(metaTitle)}
        />
        <meta key="og:url" property="og:url" content={canonicalUrl} />
        <meta
          key="og:description"
          property="og:description"
          content={metaDescription}
        />
        <meta
          key="twitter:title"
          name="twitter:title"
          content={makeLpTitle(metaTitle)}
        />
        <meta
          key="twitter:description"
          name="twitter:description"
          content={metaDescription}
        />
      </NextHead>
      <PageHeading className="container my-4">
        Games on the go: the answers
      </PageHeading>
      <SanitizeHTML
        className="container py-10"
        withStyles
        html="<h4>Name that country</h4><ol><li>Iran</li><li>France</li><li>Belize</li><li>Chile</li><li>Kuwait</li><li>Belgium</li></ol><h4>Famous places</h4><ol><li>Great Wall of China</li><li>Big Ben</li><li>Great Pyramid of Giza</li><li>Grand Canyon</li><li>Leaning Tower of Pisa</li><li>Leicester Square</li><li>Tower of London</li><li>Table Mountain</li><li>Eiffel Tower</li><li>Marble Arch</li><li>Victoria Falls</li><li>Sydney Harbour Bridge</li></ol>"
      />
    </div>
  );
}
export async function getStaticProps() {
  return {
    props: {
      children: null,
    },
  };
}
